import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AuthGuard } from "../../../shared/_guards/auth.guard";
import { StatusComponent } from "./status/status.component";
import { UsersComponent } from "./users/users.component";
import { TradingSessionsComponent } from "./trading-sessions/trading-sessions.component";
import { TradingSymbolsComponent } from "./trading-symbols/trading-symbols.component";
import { EditTradingSymbolComponent } from "./trading-symbols/edit/edit-trading-symbol.component";
import { TradingSymbolsListsComponent } from "./trading-symbols-lists/trading-symbols-lists.component";
import { EditTradingSymbolsListComponent } from "./trading-symbols-lists/edit/edit-trading-symbols-list.component";
import { PricingPackagesComponent } from "./pricing-packages/pricing-packages.component";
import { MarketplaceComponent } from "./marketplace/marketplace.component";
import { EditMarketplaceComponent } from "./marketplace/edit/edit-marketplace.component";
import { LogsComponent } from "./logs/logs.component";
import { AlertsComponent } from "./alerts/alerts.component";
import { AlertComponent } from "./alerts/alert/alert.component";

export const routes: Routes = [
    {
        path: "",
        component: StatusComponent,
        data: {
            title: "System Status",
            hideNavbar: false,
        },
        canActivate: [AuthGuard],
    },
    {
        path: "status",
        component: StatusComponent,
        data: {
            title: "System Status",
            hideNavbar: false,
        },
        canActivate: [AuthGuard],
    },
    {
        path: "users",
        component: UsersComponent,
        data: {
            title: "Users",
            hideNavbar: false,
        },
        canActivate: [AuthGuard],
    },
    {
        path: "trading-sessions",
        component: TradingSessionsComponent,
        data: {
            title: "Trading Sessions",
            hideNavbar: false,
        },
        canActivate: [AuthGuard],
    },
    {
        path: "trading-symbols",
        component: TradingSymbolsComponent,
        data: {
            title: "Trading Symbols",
            hideNavbar: false,
        },
        canActivate: [AuthGuard],
    },
    {
        path: "trading-symbols/:id",
        component: EditTradingSymbolComponent,
        data: {
            title: "Trading Symbol Edit",
            hideNavbar: false,
        },
        canActivate: [AuthGuard],
    },
    {
        path: "trading-symbols-lists",
        component: TradingSymbolsListsComponent,
        data: {
            title: "Trading Symbols Lists",
            hideNavbar: false,
        },
        canActivate: [AuthGuard],
    },
    {
        path: "trading-symbols-lists/:id",
        component: EditTradingSymbolsListComponent,
        data: {
            title: "Trading Symbols List Edit",
            hideNavbar: false,
        },
        canActivate: [AuthGuard],
    },
    {
        path: "pricing-packages",
        component: PricingPackagesComponent,
        data: {
            title: "Pricing Packages",
            hideNavbar: false,
        },
        canActivate: [AuthGuard],
    },
    {
        path: "marketplace",
        component: MarketplaceComponent,
        data: {
            title: "Marketplace",
            hideNavbar: false,
        },
        canActivate: [AuthGuard],
    },
    {
        path: "marketplace/:id",
        component: EditMarketplaceComponent,
        data: {
            title: "Edit Marketplace",
            hideNavbar: false,
        },
        canActivate: [AuthGuard],
    },
    {
        path: "alerts",
        component: AlertsComponent,
        data: {
            title: "Alerts",
            hideNavbar: false,
        },
        canActivate: [AuthGuard],
    },
    {
        path: "alerts/:id",
        component: AlertComponent,
        data: {
            title: "Alert",
            hideNavbar: false,
        },
        canActivate: [AuthGuard],
    },
    {
        path: "logs",
        component: LogsComponent,
        data: {
            title: "Logs",
            hideNavbar: false,
        },
        canActivate: [AuthGuard],
    },
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {})],
    exports: [RouterModule],
})
export class AppRoutingModule {}
